import React from 'react'
import BrandLayout from '../components/Layouts/BrandLayout'
import AuthorizationProviderContainer from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import OnboardingDialogContainer from '../containers/OnboardingDialog/OnboardingDialog.container'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import QuoteRequestPublishedSuccessfullyContainer from '../containers/QuoteRequestPublishedSuccessfully/QuoteRequestPublishedSuccessfully.container'

/**
 * The QuoteRequestPublishedSuccessfully's page.
 */
const QuoteRequestPublishedSuccessfully = () => {
  return (
    <AuthorizationProviderContainer>
      <ProtectByAccessToken>
        <BrandLayout>
          <QuoteRequestPublishedSuccessfullyContainer />
          <OnboardingDialogContainer />
        </BrandLayout>
      </ProtectByAccessToken>
    </AuthorizationProviderContainer>
  )
}

export default QuoteRequestPublishedSuccessfully
